import React from 'react';
import PropTypes from 'prop-types';
import { LANGUAGE_OPTIONS } from 'next/components/Conditions';
import { ConditionText } from './styled';

export const LanguageCondition = ({ value, negated }) => {
  const language = LANGUAGE_OPTIONS.find(item => item.value === value)?.label;
  return (
    <ConditionText>
      language must {negated ? 'not' : ''} be {language}
    </ConditionText>
  );
};

LanguageCondition.propTypes = {
  value: PropTypes.string.isRequired,
  negated: PropTypes.bool,
};

export default LanguageCondition;
